import { Loader2 } from "lucide-react";
import { trpc } from "@/lib/trpc";
import { useFeature } from "@/lib/use-feature";
import { PlanoPagoSalas } from "@/components/salas/PlanoPagoSalas";
import { ListaDeSalas, type SalaDaLista } from "@/components/settings/salas/ListaDeSalas";
import { SalasDosProfissionais } from "@/components/settings/salas/SalasDosProfissionais";

// ─── Seção "Salas" (cadeiras de atendimento) ──

/** Cada sala é uma cadeira: não atende duas consultas ao mesmo tempo. A sala de cada profissional
 *  por dia é só a sugestão ao marcar; a consulta pode ficar em outra, ou sem sala. */
export function SalasSecao() {
  const temRecurso = useFeature("salas");
  const consulta = trpc.salas.listar.useQuery({ todas: true }, { enabled: temRecurso });
  const salas = (consulta.data ?? []) as SalaDaLista[];
  if (!temRecurso) return <PlanoPagoSalas compacto />;
  if (consulta.isLoading) {
    return (
      <div className="flex justify-center py-10">
        <Loader2 className="h-5 w-5 animate-spin text-zinc-400" />
      </div>
    );
  }
  return (
    <div className="space-y-6 px-6 py-5">
      <section className="space-y-2">
        <p className="text-sm text-zinc-600 dark:text-muted-foreground">
          Cadastre cada cadeira de atendimento. Duas consultas nunca ficam na mesma sala ao mesmo tempo; dentistas diferentes em salas diferentes, sim.
        </p>
        <ListaDeSalas salas={salas} />
      </section>
      {salas.some((s) => s.ativa) && (
        <section className="space-y-2">
          <div>
            <h3 className="text-sm font-semibold text-zinc-900 dark:text-foreground">Sala de cada profissional</h3>
            <p className="text-xs text-zinc-500 dark:text-muted-foreground">Vem preenchida ao marcar a consulta daquele dia. Dá pra trocar na hora.</p>
          </div>
          <SalasDosProfissionais salas={salas} />
        </section>
      )}
    </div>
  );
}
